import { useTranslation, Trans } from 'react-i18next';

import styled from 'styled-components';
import { Spacing, Colors, Dimensions } from '@/shared/theme';
import { Title, Text } from '@/shared/ui';

import iconBarChartHeart from '@/assets/images/Landing/bar-chart-heart.svg';

import iconShieldLock from '@/assets/images/Landing/shield-with-lock.svg';
import iconMeAvatar from '@/assets/images/Landing/me-avatar.svg';
import iconMessageSupport from '@/assets/images/Landing/message-support.svg';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${Spacing.x5}px;
  width: 100vw;
  background-color: ${Colors.backgroundAlt};
`;

const WhyInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.x4}px;
  padding: ${Spacing.x5}px ${Spacing.x2}px;
`;

const WhyContentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.x2}px;
  max-width: ${Dimensions.c10}px;
`;

const WhyItem = styled.div`
  display: flex;
  gap: ${Spacing.x2}px;
  align-items: flex-start;
`;

const WhyIcon = styled.img`
  width: 48px;
  height: 48px;
`;

const WhyCopy = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${Spacing.x1}px;
`;

const WhySection = () => {
  const { t } = useTranslation();
  return (
    <Container id="why-hello-heart">
      <WhyInner>
        <Title size="h3" bold centered as="h2">
          {t('landing.why-title')}
        </Title>
        <WhyContentList>
          <WhyItem>
            <WhyIcon src={iconBarChartHeart} alt="" aria-hidden="true" />
            <WhyCopy>
              <Text size="h6" bold>
                {t('landing.why-proven-title')}
              </Text>
              <Text size="p1">{t('landing.why-proven-description')}</Text>
            </WhyCopy>
          </WhyItem>
          <WhyItem>
            <WhyIcon src={iconMeAvatar} alt="" aria-hidden="true" />
            <WhyCopy>
              <Text size="h6" bold>
                {t('landing.why-trusted-title')}
              </Text>
              <Text size="p1">{t('landing.why-trusted-description')}</Text>
            </WhyCopy>
          </WhyItem>
          <WhyItem>
            <WhyIcon src={iconShieldLock} alt="" aria-hidden="true" />
            <WhyCopy>
              <Text size="h6" bold>
                {t('landing.why-privacy-title')}
              </Text>
              <Text size="p1">{t('landing.why-privacy-description')}</Text>
            </WhyCopy>
          </WhyItem>
          <WhyItem>
            <WhyIcon src={iconMessageSupport} alt="" aria-hidden="true" />
            <WhyCopy>
              <Text size="h6" bold>
                {t('landing.why-support-title')}
              </Text>
              <Text size="p1">
                <Trans
                  i18nKey="landing.why-support-description"
                  components={{
                    1: <strong />,
                  }}
                />
              </Text>
            </WhyCopy>
          </WhyItem>
        </WhyContentList>
      </WhyInner>
    </Container>
  );
};

export default WhySection;
